var styles = {
  "InlineGrid": "Polaris-InlineGrid"
};

export { styles as default };
